import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography,Box  } from '@material-ui/core'

function AlertModal({ open, title, message, onSubmit, onCancel, submitButtonTitle, cancelButtonTitle, submitButtonProps }) {
    const { t } = useTranslation()
    const classes = useStyles()
    const submitTitle = submitButtonTitle || t('ok').toUpperCase()
    const cancelTitle = cancelButtonTitle || t('cancel').toUpperCase()

    return (
        <Dialog open={open} aria-labelledby="alert">
            <DialogTitle id="alert-title" disableTypography>
                <Typography component="h3">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText>
                    <Typography component="span">{message}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogContent}>
                <Box className={classes.cancelButton}>
                    {onCancel && <Button onClick={onCancel} color="primary">
                        {cancelTitle}
                    </Button>}
                </Box>
                <Box>
                    {
                        onSubmit && <Button onClick={onSubmit} color="primary" variant="contained" {...submitButtonProps} >
                            {submitTitle}
                        </Button>
                    }
                </Box>
            </DialogActions>
        </Dialog >
    )
}

const useStyles = makeStyles(theme => ({
    dialogContent: {
        padding: 20,
        '&:last-child': {
            paddingTop: 0
        }
    },
    cancelButton: {
        display: 'flex',
        flex: 1
    }
}))

export default AlertModal